import { useClientAllListData, useClientListData } from "./clientApis";

export const useMerchantAllListData = useClientAllListData;
export const useMerchantListData = (
  page?: number,
  limit?: number,
  searchFor?: string,
  entityType?: string
) => {
  return useClientListData(page || 1, searchFor || "");
};
export const useAllFMMerchantData = useClientAllListData;

export default useMerchantAllListData;
